<script lang="ts">
    import type {GenericDatatypedFilterDefinition, RecordFilterableDatatype} from '../../types';
    import DatatypeValueEditor from './DatatypeValueEditor.svelte';

    export let valueFilterDefinition: GenericDatatypedFilterDefinition<RecordFilterableDatatype>;
</script>

<DatatypeValueEditor filterableDatatypeDefinition={valueFilterDefinition}/>
